<template>
    <v-card>
        <v-dialog v-model="message.status" width="500">
            <v-alert
                    class="mx-auto my-12"
                    max-width="500"
                    v-model="message.status"
                    dismissible
                    prominent
                    :type="message.color"
            >{{ message.text }}
            </v-alert>
        </v-dialog>
        <v-card-title v-if="'لیست تیکت های من'!==''">لیست تیکت های من</v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="12" v-if="page.headerSidebar.widget.length>0">
                    <v-row>
                        <page-render
                                :widgets="page.headerSidebar.widget"
                                editOrShowTarget="nothing"
                                @get-page="get_page"
                                @filter-page="get_page"
                                @on-pagination="onPagination"
                                @on-pagination-into-dialog-or-group="onPaginationNested"
                                paramId="0"
                                :requestApiUrl="this.page.requestApiUrl"
                        />
                    </v-row>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="3" xl="2" v-if="page.rightSidebar.widget.length>0">
                    <v-row>
                        <page-render
                                :widgets="page.rightSidebar.widget"
                                editOrShowTarget="nothing"
                                @get-page="get_page"
                                @filter-page="get_page"
                                @on-pagination="onPagination"
                                @on-pagination-into-dialog-or-group="onPaginationNested"
                                paramId="0"
                                :requestApiUrl="this.page.requestApiUrl"
                        />
                    </v-row>
                </v-col>
                <v-col :cols="mainContentSize.size" sm="12" :md="mainContentSize.sizeMd" :lg="mainContentSize.sizeLg"
                       :xl="mainContentSize.sizeXl">
                    <v-row>
                        <page-render
                                :widgets="page.content.widget"
                                editOrShowTarget="nothing"
                                @get-page="get_page"
                                @filter-page="get_page"
                                @on-pagination="onPagination"
                                @on-pagination-into-dialog-or-group="onPaginationNested"
                                paramId="0"
                                :requestApiUrl="this.page.requestApiUrl"
                        />
                    </v-row>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="3" xl="2" v-if="page.leftSidebar.widget.length>0">
                    <v-row>
                        <page-render
                                :widgets="page.leftSidebar.widget"
                                editOrShowTarget="nothing"
                                @get-page="get_page"
                                @filter-page="get_page"
                                @on-pagination="onPagination"
                                @on-pagination-into-dialog-or-group="onPaginationNested"
                                paramId="0"
                                :requestApiUrl="this.page.requestApiUrl"
                        />
                    </v-row>
                </v-col>
                <v-col cols="12" v-if="page.footerSidebar.widget.length>0">
                    <v-row>
                        <page-render
                                :widgets="page.footerSidebar.widget"
                                editOrShowTarget="nothing"
                                @get-page="get_page"
                                @filter-page="get_page"
                                @on-pagination="onPagination"
                                @on-pagination-into-dialog-or-group="onPaginationNested"
                                paramId="0"
                                :requestApiUrl="this.page.requestApiUrl"
                        />
                    </v-row>
                </v-col>
            </v-row>
            <v-row>

            </v-row>
        </v-card-text>
        <v-footer>{{ page.content.copyright }}</v-footer>
    </v-card>
</template>

<script>
    // eslint-disable-next-line import/extensions
    import axios from '@axios'
    import router from '@/router'
    import baseConfig from '@/../baseConfig'
    import PageRender from '@/views/generator/page-render';
    import {tableDateHandler,formConfig,tablePaginationHandler,initialSidebarsSize,initGroups}
        from "@/views/generator/page-handler";

    export default {
        components: {
            PageRender,
        },
        data() {
            return {
                mainContentSize: {
                    size: 12,
                    sizeSm: 12,
                    sizeMd: 12,
                    sizeLg: 12,
                    sizeXl: 12,
                },
                message: {
                    status: false,
                    text: "success operation",
                    color: "success"
                },
                page: {
                    content: {},
                    headerSidebar: {
                        widget: []
                    },
                    leftSidebar: {
                        widget: []
                    },
                    rightSidebar: {
                        widget: []
                    },
                    footerSidebar: {
                        widget: []
                    },
                },
                pagination: [],
                paginationToQueryString: "?",
                deleteUrl: ""
            }
        },
        beforeCreate() {

            /*if (localStorage.getItem("accessToken") === "undefined" || localStorage.getItem("accessToken") === undefined || localStorage.getItem("accessToken") === "null" || localStorage.getItem("accessToken") === null || localStorage.getItem("accessToken") === "") {
                router.push('/login')
            }*/
        },
        mounted() {
            this.get_page()
        },
        methods: {
            //dynamic ddl from request here
            async onPagination(name, current, filter) {
                this.pagination.find(p => p.table == name).page = current
                this.paginationToQueryString = "?"
                this.pagination.map(p => this.paginationToQueryString += p.table + "=" + p.page + "&")
                if (filter.id === 0)
                    this.get_page()
                else {
                    await axios.post(filter.action + this.paginationToQueryString, filter.body).then(r => {
                        this.get_page(r.data.data.page)
                    })
                }
            },
            async onPaginationNested(name, current, filter) {
                console.log("nesed")
                console.log(filter)
                console.log("unfortunately not work on nested situation this needs more assessment, handled this error for groups")
               // this.pagination.find(p => p.table == name).page = current
               /* this.paginationToQueryString = "?"
                this.pagination.map(p => this.paginationToQueryString += p.table + "=" + p.page + "&")
                if (filter.id === 0)
                    this.get_page()
                else {
                    await axios.post(filter.action + this.paginationToQueryString, filter.body).then(r => {
                        this.get_page(r.data.data.page)
                    })
                }*/
            },
            initing(){
                this.page.content.widget = formConfig(this.page.content.widget)
                this.page.leftSidebar.widget = formConfig(this.page.leftSidebar.widget)
                this.page.rightSidebar.widget = formConfig(this.page.rightSidebar.widget)
                this.page.headerSidebar.widget = formConfig(this.page.headerSidebar.widget)
                this.page.footerSidebar.widget = formConfig(this.page.footerSidebar.widget)

                this.page.content.widget = tableDateHandler(this.page.content.widget)
                this.page.leftSidebar.widget = tableDateHandler(this.page.leftSidebar.widget)
                this.page.rightSidebar.widget = tableDateHandler(this.page.rightSidebar.widget)
                this.page.headerSidebar.widget = tableDateHandler(this.page.headerSidebar.widget)
                this.page.footerSidebar.widget = tableDateHandler(this.page.footerSidebar.widget)

                this.page.content.widget=initGroups(this.page.content.widget)
                this.page.leftSidebar.widget=initGroups(this.page.leftSidebar.widget)
                this.page.rightSidebar.widget=initGroups(this.page.rightSidebar.widget)
                this.page.headerSidebar.widget=initGroups(this.page.headerSidebar.widget)
                this.page.footerSidebar.widget=initGroups(this.page.footerSidebar.widget)


            },
            async get_page(getFilteredData = null) {

                const body = new FormData()
                let tables = this.paginationToQueryString.split("&");
                if( this.paginationToQueryString!=="?")
                    tables.map(t => {
                        t = t.replaceAll("?", "")
                        t = t.replaceAll("&", "")
                        let tablesAndPage = t.split("=");
                        let tableName = tablesAndPage[0]
                        let tablePage = tablesAndPage[1]
                        console.log(tableName, tablePage)
                        if (tableName+"Filter"!=="Filter") {
                            body.append("widget[]", tableName + "Filter")

                            if (typeof this.page.content.widget !== "undefined")
                                this.page.content.widget.map(w => {
                                    if (w.type === 'tabGroup') {
                                        w.data.tab.map(t => {
                                            t.widget.map(cw => {
                                                cw.data.tab.map(tt => {
                                                    tt.widget.map(fw => {
                                                        if (fw.data.name === tablesAndPage[0] + "Filter")
                                                            fw.data.elements.map(e => {
                                                                if (e.type !== "submit")
                                                                    body.set(e.name, e.model)
                                                            })
                                                    })
                                                })
                                            })
                                        })
                                    }
                                })
                        }


                    })


                if (getFilteredData === null) {
                    try {
                       await axios.post(baseConfig.baseUrl + 'my/ticket' + this.paginationToQueryString,body).then(r => {
                            if (typeof r.data.status==="undefined") {
                                if (localStorage.getItem("accessToken") === "undefined" || localStorage.getItem("accessToken") === undefined || localStorage.getItem("accessToken") === "null" || localStorage.getItem("accessToken") === null || localStorage.getItem("accessToken") === "") {
                                    router.push('/login')
                                }
                            }
                            if (r.data.status!=="error") {
                                this.page = r.data.data.page
                                this.initing()

                                document.title = this.page.name

                                if (this.paginationToQueryString === "?") {
                                    this.pagination = tablePaginationHandler(this.page.content.widget, this.page.leftSidebar.widget, this.page.rightSidebar.widget, this.page.headerSidebar.widget, this.page.footerSidebar.widget)
                                    this.paginationToQueryString = "?"
                                    this.pagination.map(p => this.paginationToQueryString += p.table + "=" + p.page + "&")
                                }
                                this.mainContentSize = initialSidebarsSize(this.page)
                            }else {
                                this.message.status=true
                                this.message.text=r.data.message
                                this.message.color="error"
                                setTimeout(() => {
                                    this.message.status = false
                                }, 30000)
                            }
                           this.page.content.widget.map(w=>{
                               if (w.type==='form' && typeof w.data.valid!=='undefined'){
                                   let disableValidation=true
                                   w.data.elements.map(e => e.type!=='dropdown' & e.validations.length!==0 ? disableValidation=false : null)
                                   if (disableValidation)
                                       w.data.valid=disableValidation
                               }
                           })
                        })
                    }
                    catch(err) {
                        if(err.response.status===401)
                            await this.$router.push('/login')
                        if(err.response.status===503) {
                            this.message = {
                                status: true,
                                text: "وبسایت در دست تعمیرات است",
                                color: "red"
                            }
                        }

                    }

                } else {
                    this.page = getFilteredData
                    this.initing()

                    document.title = this.page.name
                    if (this.paginationToQueryString === "?") {
                        this.pagination = tablePaginationHandler(this.page.content.widget, this.page.leftSidebar.widget, this.page.rightSidebar.widget, this.page.headerSidebar.widget, this.page.footerSidebar.widget)
                        this.paginationToQueryString = "?"
                        this.pagination.map(p => this.paginationToQueryString += p.table + "=" + p.page + "&")
                    }
                    this.mainContentSize = initialSidebarsSize(this.page)
                }

            },
        },
    }
</script>

<style>
    .v-alert {
        position: fixed !important;
        left: 50% !important;;
        transform: translate(-50%, -50%) !important;;
        margin: 0 auto !important;;
        z-index: 9999 !important;
    }

</style>
